/**
 * Returns a new object with converted javascript dates without mutating data
 *
 * @param {Object} data
 * @returns {Object}
 */
export default function formatDateData(data) {
  // convert the dates to actual javascript dates
  return {
    ...data,
    lastUsedTime: new Date(data.lastUsedTime || data.createTime),
    createTime: new Date(data.createTime)
  }
}
